/**
 * Smooth scroll functionality for CTA buttons and anchor links
 * Usage: <button data-scroll-to=".target-element">Scroll to Target</button>
 */

// Simple global document-level delegation for scroll-to functionality
document.addEventListener('click', function (event) {
    const scrollButton = event.target.closest('[data-scroll-to]');
    if (!scrollButton) return;

    event.preventDefault();

    const targetSelector = scrollButton.dataset.scrollTo;
    const targetElement = document.querySelector(targetSelector);

    if (targetElement) {
        // Position element in the center of the viewport
        const elementPosition = targetElement.getBoundingClientRect().top;
        const viewportHeight = window.innerHeight;
        const elementHeight = targetElement.getBoundingClientRect().height;
        
        // Calculate position to center the element in viewport
        const centerOffset = (viewportHeight - elementHeight) / 2;
        const offsetPosition = elementPosition + window.pageYOffset - centerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });

        // Log for debugging
        console.log('Scrolling to center:', targetSelector, targetElement);
    } else {
        console.warn('Scroll target not found:', targetSelector);
    }
});